import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const TimeZoneRangePicker = ({ setRange, disabledDate, timezoneToday }) => {
  return (
    <RangePicker
      onChange={(val) => setRange(val)}
      disabledDate={disabledDate}
      cellRender={(date, info) => {
        const isTimezoneToday = date.isSame(timezoneToday, "day");
        const defaultNode = info.originNode;

        return (
          <div style={{ position: "relative" }}>
            {defaultNode}
            {isTimezoneToday && (
              <div
                style={{
                  position: "absolute",
                  top: 2,
                  left: 2,
                  right: 2,
                  bottom: 2,
                  borderRadius: "4px",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  pointerEvents: "none",
                  fontSize: "12px",
                }}
              >
                {date.date()}
              </div>
            )}
          </div>
        );
      }}
    />
  );
};

export default TimeZoneRangePicker;
